export class ApiClient {
  static async request(url, options = {}) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    const defaultOptions = {
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': csrfToken,
        ...options.headers
      }
    }

    const finalOptions = {
      ...defaultOptions,
      ...options,
      headers: {
        ...defaultOptions.headers,
        ...options.headers
      }
    }

    const response = await fetch(url, finalOptions)

    if (!response.ok) {
      const error = await this.parseError(response)
      throw new Error(error)
    }

    return response
  }

  static async get(url, params = {}) {
    const searchParams = new URLSearchParams(params).toString()
    const fullUrl = searchParams ? `${url}?${searchParams}` : url
    return this.request(fullUrl)
  }

  static async post(url, data, options = {}) {
    const body = data instanceof FormData ? data : JSON.stringify(data)
    const headers = data instanceof FormData
      ? {}
      : { 'Content-Type': 'application/json' }

    // optionsからheadersを除外して、headersは別途マージする
    const { headers: optionHeaders, ...restOptions } = options

    return this.request(url, {
      method: 'POST',
      body,
      headers: { ...headers, ...optionHeaders },
      ...restOptions
    })
  }

  static async parseError(response) {
    try {
      const data = await response.json()
      return data.error || data.errors?.join('\n') || `エラーが発生しました (${response.status})`
    } catch {
      return `サーバーエラーが発生しました (${response.status})`
    }
  }
}
